<ng-container *ngIf="(notification$ | async) as notification">
    <div [@fade]="notification ? 'fadeIn' : ''" class="notification with-icon" [class]="notification.type" role="alert"
        aria-labelledby="not2-title" id="not2">
        <h5 id="not2-title">
            <bl-icon [class]="'icon'" [icon]="'check-circle'"></bl-icon>
            {{(notification.data?.title || 'notification.' + notification.type) | translate}}
        </h5>
    </div>
</ng-container>
